import Typography from 'components/shared/generic/typography/presentational/Typography';
import React from 'react';
import useTranslate from 'suits-me-npm/languages/useTranslate';

const TermsAndConditions = () => {
    const translate = useTranslate('termsAndConditions');
    return (
        <div className="terms-and-conditions-container">
            <div className="terms-section">
                <Typography>{translate('textBody')}</Typography>
            </div>
        </div>
    );
};

export default TermsAndConditions;
